module.exports = __webpack_public_path__ + "static/media/kaci-baum-1.dc930681.jpg";